import React from 'react'
import { findStatus, Status } from '@ztechapps/webui.util'
import { BlogStatus as BlogStatusConfig } from '@ztechapps/blog.common'
import './BlogStatus.scss'

type BlogStatusProps = { value?: string }

export const BlogStatus = ({ value }: BlogStatusProps) => {
  const statusColor = findStatus(BlogStatusConfig, value)?.color

  return <Status value={value} color={statusColor} />
}
